(function () {
    'use strict';
    $(() => {
        if ($('.publications-form').length) {
            const $form = $('form.publications-form');
            const $checkboxes = $('.publications-form input[type="checkbox"]');
            const $loadMorePublications = $('#load-more-publications');
            $checkboxes.on('change', (e) => {
                const checkboxName = $(e.target).attr('name');

                $checkboxes.each(function () {
                    if ($(this).attr('name') !== checkboxName) {
                        $(this).prop('checked', false);
                    }
                });
            });

            $form.on('submit', (e) => {
                e.preventDefault();
                handleSearch('form')
            });

            $loadMorePublications.on('click', function () {
                const href = $(this).attr('data-href');
                if (href) {
                    handleSearch('show_more_button', href);
                }
            });

            function handleSearch(submitSource = 'form', nextUrl = '') {
                const formData = $form.serializeArray();
                const searchValue = formData[0].value; // input value

                // If input isn't empty
                // create a query and submit data
                if (searchValue.trim().length > 0) {
                    const afValue = `af-id(60085460)`;
                    const filterValue = formData.length > 1 ? `${formData[1].value.toUpperCase()}(${searchValue})` : searchValue;

                    const query = `${afValue} AND ${filterValue}`;
                    console.log('query:', query);

                    if (!$form.hasClass('disabled')) {
                        $.ajax({
                            url: "/wp-admin/admin-ajax.php",
                            method: "post",
                            timeout: 10000,
                            data: {
                                action: "get_publications",
                                query,
                                nextUrl
                            },
                            beforeSend: function () {
                                $loadMorePublications.addClass('disabled');
                                $form.addClass('disabled');
                                if (submitSource !== 'show_more_button') {
                                    $('#publications-from-ajax').slideUp();
                                }
                                $('.ajax-info-publications .loading-error').slideUp();
                                $('.ajax-info-publications .loader').slideDown();
                            },
                            success: function (raw_data) {
                                const data = JSON.parse(raw_data)['search-results'];
                                const $wrapper = $('#publications-from-ajax');

                                // Set link to next page if it exists
                                const newNextUrl = data.link.find(l => l['@ref'] === 'next')
                                    ? data.link.find(l => l['@ref'] === 'next')['@href']
                                    : '';


                                // from 'show more' button clicked
                                if (submitSource === 'show_more_button') {
                                    $wrapper.append(formatPublications(data));
                                } else { // from form submition
                                    $wrapper.html(formatPublications(data));
                                }
                                $wrapper.slideDown();

                                if (newNextUrl) {
                                    $loadMorePublications
                                        .attr('data-href', newNextUrl)
                                        .removeClass('d-none');
                                } else {
                                    $loadMorePublications
                                        .attr('data-href', '')
                                        .addClass('d-none');
                                }
                            },
                            error: function (err) {
                                console.log('error', err);
                                $('.ajax-info-publications .loading-error').slideDown();
                            },
                            complete: function () {
                                $loadMorePublications.removeClass('disabled');
                                $form.removeClass('disabled');
                                $('.ajax-info-publications .loader').slideUp();
                            }
                        });
                    }

                } else {
                    console.log('Empty search')
                }

            }

            function formatPublications(data) {
                console.log(data);
                return data.entry.map((publication, index) => `
                    <article class="publication">
                        <div class="category">${publication["prism:publicationName"]}</div>
                        <h3 class="title"><a target="_blank" href="https://www.scopus.com/inward/record.uri?partnerID=HzOxMe3b&scp=${publication["dc:identifier"].replace('SCOPUS_ID:', "")}&origin=inward">${publication["dc:title"]}</a></h3>
                        <ul class="authors">
                            ${publication['author'].map((author) => `
                                <li>
                                    <a target="_blank" href="https://www.scopus.com/authid/detail.uri?authorId=${author['authid']}" className="author">${author['authname']}</a>
                                </li>
                            `).join('')}
                        </ul>
                        <div class="meta">
                            <div class="meta-item date">${publication["prism:coverDate"]}</div>
                            <div class="meta-item type">${publication["subtypeDescription"]}</div>
                            <div class="meta-item doi"><a target="_blank" href="https://dx.doi.org/${publication["prism:doi"].replace('SCOPUS_ID:', "")}">DOI: ${publication["prism:doi"]}</a></div>
                        </div>
                    </article>
                `).join('');
            }
        }
    });
}(jQuery));
